<template>
  <Space v-if="icon || name">
    <template v-if="['ant-sousuo', 'ant-shuaxin'].includes(icon)">
      <SearchOutlined v-if="icon === 'ant-sousuo'" />
      <SyncOutlined v-if="icon === 'ant-shuaxin'" />
    </template>
    <icon-font v-else :type="icon || name" />
    <slot></slot>
  </Space>
</template>
<script>
import { Space } from 'ant-design-vue'
import { createFromIconfontCN } from '@ant-design/icons-vue'
import { SearchOutlined, SyncOutlined } from '@ant-design/icons-vue'

const IconFont = createFromIconfontCN({
  scriptUrl: 'https://cms.jtexpress.com/spm/common/curd-icons/iconfont.js'
})
export default {
  name: 'SmartIcon',
  props: ['icon', 'name'],
  components: {
    IconFont,
    Space,
    SearchOutlined,
    SyncOutlined
  }
}
</script>
<style scoped>
.icons-list :deep(.anticon) {
  font-size: 24px;
}
</style>
